export const getCustomTagNameByIdFor = (contentTagAliases) => {
  return contentTagAliases.reduce((map, contentTagAlias) => {
    map[contentTagAlias.contentTagId] = contentTagAlias.alias;
    return map;
  }, {});
};

export const getCustomTagNameByIdForByOrgSettings = (orgSettings) => {
  return getCustomTagNameByIdFor(orgSettings?.contentTagAliases ?? []);
};
